// extracted by mini-css-extract-plugin
module.exports = {"root":"PageHeaderBlock_root__GZ2qB","content":"PageHeaderBlock_content__ghXC6","title":"PageHeaderBlock_title__cKqqJ","text":"PageHeaderBlock_text__QuWc7"};